module.exports = __webpack_public_path__ + "static/media/calendar-plus.d0ece8d3.svg";